import React from 'react';
import { AssetIcon } from 'assets/icons/AssetIcon';
import TimerText from 'components/timer-text/TimerText';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useSoundContext } from 'context/SoundContext';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { usePageTimer } from 'hooks/usePageTimer';
import { useTranslation } from 'hooks/useTranslation';
import { useNavigate } from 'react-router';
import { setSelfeAppStateAction } from 'store/features/app/selfeAppSlice';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import './select-payment-method.css';

function SelectPaymentMethod() {
  const dispatch = useAppDispatch();
  const { T } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const navigate = useNavigate();
  const { audio } = useSoundContext();
  const { getNextPath } = useNewPhotoLifeCycleStep();
  const { isTurnOnVNPayMethodPayment } = useAppSelector((s) => s.booth);
  const { second } = usePageTimer({
    forwardFunc: () => handleSelectPaymentMethod()(),
  });

  // handle select frame
  const handleSelectPaymentMethod =
    (isUseQRCode = false) =>
    () => {
      audio?.playContinueClick?.();
      dispatch(
        setSelfeAppStateAction({
          isChoosePaymentMethod: true,
          isChooseQRCodeToPay: isUseQRCode,
          isChooseVNPayToPay: isUseQRCode && isTurnOnVNPayMethodPayment,
        }),
      );
      navigate(getNextPath() || '');
    };

  return (
    <div className="select-payment-method">
      <TimerText second={second} />
      <div className="select-payment-method__btn-group">
        <button
          type="button"
          className="select-payment-method__btn"
          onClick={handleSelectPaymentMethod()}
        >
          <div className="select-payment-method__title-wrapper">
            <Typography variant={TYPOGRAPHY_VARIANTS.H2}>
              {T(`${I18nNamespace.COMMON}:cash`)}
            </Typography>
          </div>
          <div className="select-payment-method__image-wrapper">
            <AssetIcon.MoneyBigIcon />
          </div>
        </button>
        <button
          type="button"
          className="select-payment-method__btn"
          onClick={handleSelectPaymentMethod(true)}
        >
          <div className="select-payment-method__title-wrapper">
            <Typography variant={TYPOGRAPHY_VARIANTS.H2}>
              {T(`${I18nNamespace.COMMON}:qrCode`)}
            </Typography>
          </div>
          <div className="select-payment-method__image-wrapper">
            <AssetIcon.QRCodeBigIcon />
          </div>
        </button>
      </div>
    </div>
  );
}

export default SelectPaymentMethod;
